export default "__VITE_ASSET__5ae29908__"